import { AxiosRequestConfig, AxiosResponse } from 'axios';
import {
  getAssembleiasAssessorMessengerEndpoint,
  getDuvidasFrequentesEndpoint,
} from 'library/Apis';
import api from 'services/ApiService';

export interface ErrorAPI {
  code: string;
  details: ErrorAPI[];
  error: string;
  message: string;
}

interface ResponseAPI<T> {
  fail?: ErrorAPI;
  data?: T;
  response?: AxiosResponse<T>;
}

export interface Success {
  body: any;
  statusCode: string;
  statusCodeValue: number;
}

const generic = { message: 'Ocorreu algo inesperado' };

export async function get<T>(
  endpoint: string,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getDuvidasFrequentesEndpoint()}${endpoint}`;
  try {
    const response = await api.get<T>(url, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    return {
      fail: (error as any).response?.data || generic,
    };
  }
}

export async function messengerGet<T>(
  endpoint: string,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getAssembleiasAssessorMessengerEndpoint()}${endpoint}`;
  try {
    const response = await api.get<T>(url, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    return {
      fail: (error as any).response?.data || generic,
    };
  }
}

export async function post<T>(
  endpoint: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getDuvidasFrequentesEndpoint()}${endpoint}`;
  try {
    const response = await api.post<T>(url, data, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    return {
      fail: (error as any).response?.data || generic,
    };
  }
}

export async function messengerPost<T>(
  endpoint: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getAssembleiasAssessorMessengerEndpoint()}${endpoint}`;
  try {
    const response = await api.post<T>(url, data, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    return {
      fail: (error as any).response?.data || generic,
    };
  }
}

export async function put<T>(
  endpoint: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getDuvidasFrequentesEndpoint()}${endpoint}`;
  try {
    const response = await api.put<T>(url, data, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    return {
      fail: (error as any).response?.data || generic,
    };
  }
}

export async function messengerPut<T>(
  endpoint: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getAssembleiasAssessorMessengerEndpoint()}${endpoint}`;
  try {
    const response = await api.put<T>(url, data, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    return {
      fail: (error as any).response?.data || generic,
    };
  }
}
